export default {"src":"/_next/static/media/cross.183cdb75.svg","height":294,"width":293,"blurWidth":0,"blurHeight":0};